/**
 * Chats op de telefoon (19-10-2026, Jordy): één rij chips bovenaan met de
 * tellers van de panelen, zodat de inbox in één oogopslag te overzien is. Een
 * tik springt naar dat paneel. Alleen gerenderd onder 900px (lib/mobiel).
 *
 * Het paneel wordt op zijn titel gevonden (SidePanel zet die in de h3), zodat
 * de panelen zelf niet hoeven te veranderen.
 */
export interface InboxChip {
  /** De titel van het paneel zoals SidePanel hem toont. */
  paneel: string
  label: string
  aantal?: number
  urgent?: boolean
}

function springNaar(titel: string) {
  const koppen = Array.from(document.querySelectorAll<HTMLElement>('.panel .head h3'))
  // Niet startsWith: voor de titel staat soms het prio-nummer ("1Waiting queue").
  const kop = koppen.find((h) => (h.textContent ?? '').includes(titel))
  kop?.closest('.panel')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

export function MobielInboxChips({ chips }: { chips: InboxChip[] }) {
  return (
    <nav className="minboxchips" aria-label="Jump to panel">
      {chips.map((c) => (
        <button key={c.paneel} type="button"
                className={c.urgent ? 'minboxchip urgent' : 'minboxchip'}
                onClick={() => springNaar(c.paneel)}>
          {c.label}
          {c.aantal === undefined ? null : <b>{c.aantal}</b>}
        </button>
      ))}
    </nav>
  )
}
